export const CHECKLIST = [
  {
    displaySection: "데이터 준비도",
    label: "Agent 활용 가능한 데이터·문서·업무 이력이 존재하며 활용 가능한가?",
    options: [
      {
        label: "[미준비] 필요한 데이터가 없거나 활용이 불가한 상태",
        value: 1,
      },
      {
        label:
          "[잘 모름] 데이터 존재 여부나품질 수준을 명확히 파악하지 못하고 있음",
        value: 3,
      },
      {
        label:
          "[일부 준비] 데이터는 존재하나 품질·권한·정비 수준에 일부 미흡한 사항이 있음",
        value: 5,
      },
      {
        label:
          "[준비됨] 데이터가 존재하고, 품질·최신성·접근 권한이 체계적으로 관리되고 있음",
        value: 7,
      },
    ],
  },
  {
    displaySection: "업무 정의 수준",
    label: "Agent가 수행할 업무 범위와 자동화 수준이 명확히 정의되어 있는가?",
    options: [
      {
        label: '"AI로 자동화" 수준의 막연한 요구만 존재',
        value: 1,
      },
      {
        label: "어떤 업무에 적용 가능한지 대략적인 수준에서만 파악하고 있음",
        value: 3,
      },
      {
        label: "업무 범위는 정의되어 있으나 예외 처리나 KPI가 미흡한 수준",
        value: 5,
      },
      {
        label:
          "업무 범위, 자동화 수준, 예외 처리, KPI가 구체적으로 정의되어 있음",
        value: 7,
      },
    ],
  },
  {
    displaySection: "시스템 연동 가능성",
    label: "기존 ERP, CRM, 그룹웨어, MES 등과의 연동 가능성이 확인되어 있는가?",
    options: [
      {
        label: "연동 대상 시스템 및 API 현황 미확인",
        value: 1,
      },
      {
        label: "연동 필요 여부를 명확히 파악하지 못하고 있음",
        value: 3,
      },
      {
        label: "연동 대상은 존재하나 API 권한 확인이 필요한 상태",
        value: 5,
      },
      {
        label: "연동 대상, API, 인증, 조회/입력 범위가 확인되어 있음",
        value: 7,
      },
    ],
  },
  {
    displaySection: "보안·규제 적합성",
    label: "외부 SaaS, 데이터 반출, 개인정보 처리 기준이 검토되어 있는가?",
    options: [
      {
        label: "보안 정책상 사용이 어렵거나 관련 기준 자체가 부재한 상태",
        value: 1,
      },
      {
        label: "외부 AI 사용 가능 여부를 파악하지 못하고 있음",
        value: 3,
      },
      {
        label: "보안 검토가 필요하나 큰 제약은 없는 것으로 판단됨",
        value: 5,
      },
      {
        label: "보안 정책, 개인정보 기준, 로그·감사 요건이 모두 충족되어 있음",
        value: 7,
      },
    ],
  },
  {
    displaySection: "Agent 운영통제",
    label: "Agent의 실행 권한, 승인 기준, 로그, 중단 기준이 정의되어 있는가?",
    options: [
      {
        label: "실행 권한·승인·로그 기준이 전무한 상태",
        value: 1,
      },
      {
        label: "Agent 통제의 필요성은 인지하고 있으나 구체적 방안이 없음",
        value: 3,
      },
      {
        label: "일부 기준은 존재하나 실행 통제 체계가 미흡한 상태",
        value: 5,
      },
      {
        label: "권한, 승인, 로그, 롤백, Human-in-the-loop 기준이 수립되어 있음",
        value: 7,
      },
    ],
  },
  {
    displaySection: "조직·의사결정 준비도",
    label: "현업, IT, 보안, 예산, 의사결정자가 정해져 있는가?",
    options: [
      {
        label: "책임자, 예산, 의사결정자 모두 미확정",
        value: 1,
      },
      {
        label: "담당자나 의사결정 구조가 불명확한 상태",
        value: 3,
      },
      {
        label: "추진 부서는 존재하나 예산·보안 참여 등 일부가 미흡한 상태",
        value: 5,
      },
      {
        label:
          "현업 오너, IT/보안 참여, 예산 및 의사결정자가 명확히 확정되어 있음",
        value: 7,
      },
    ],
  },
  {
    displaySection: "PoC 실행 가능성",
    label: "소규모로 검증할 PoC 대상과 성공 기준이 설정되어 있는가?",
    options: [
      {
        label: "PoC 대상·데이터·일정이 전무한 상태",
        value: 1,
      },
      {
        label: "PoC를 어떻게 진행해야 할지 방향을 파악하지 못하고 있음",
        value: 3,
      },
      {
        label: "PoC 의지는 있으나 성공 기준·범위에 일부 미흡한 사항이 있음",
        value: 5,
      },
      {
        label: "PoC 범위, 데이터, 사용자, 일정, 성공 기준이 정의되어 있음",
        value: 7,
      },
    ],
  },
  {
    displaySection: "운영·확산 가능성",
    label:
      "도입 후 운영, 장애 대응, SLA, 사용자 교육, 확산 계획이 수립되어 있는가?",
    options: [
      {
        label: "운영 책임·장애 대응·확산 계획 모두 미수립",
        value: 1,
      },
      {
        label: "도입 후 운영 방식을 구체적으로 파악하지 못하고 있음",
        value: 3,
      },
      {
        label: "운영 방안은 있으나 SLA·변화관리가 미흡한 수준",
        value: 5,
      },
      {
        label:
          "운영 담당, SLA, 장애 대응, 교육, 확산 계획이 포괄적으로 수립되어 있음",
        value: 7,
      },
    ],
  },
];
